import React from 'react'
import styled from 'styled-components'

import Button from 'components/reusable/button'
import SvgCrossMarkSolid from 'components/reusable/svg/svg_cross_mark_solid'
import { colors } from 'helpers/colors'
import { cardBoxShadow } from 'helpers/style'
import SvgCrossMarkOutlineV2 from 'components/reusable/svg/svg_cross_mark_outline_v2'
import ApplicationHelper from 'helpers/application_helper'

const StyledCloseBtn = styled(Button)`
  position: absolute;
  right: 16px;
  top: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${colors.light};
  ${cardBoxShadow}
  z-index: 2;
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    right: 12px;
    top: 12px;
  }
`

const ModalCloseButtonV2 = ({ onClose, className }) => {
  const isMobile = ApplicationHelper.isMobile

  return (
    <StyledCloseBtn type="semantic-wrapper" onClick={onClose} className={className}>
      <SvgCrossMarkOutlineV2 size={isMobile ? 12 : 16} />
    </StyledCloseBtn>
  )
}

export default ModalCloseButtonV2
